import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';


const AlertBar = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SetMuiAlert = (props:any) => {
    return (
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={props.open}>
            <AlertBar severity={props.severity} sx={{ width: '100%' }}>
                {props.message}
            </AlertBar>
        </Snackbar>
    );
};
export default SetMuiAlert;
